// Display only. Some POS feeds send "LAST,FIRST"; the raw value is what the
// backend matches on, so it is tidied here rather than at import.
export function formatPOSName(name) {
    return (name || '').replace(/\s*,\s*/g, ', ').trim()
}
